import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import authService from './services/auth/authService';

// Force-fetch reCAPTCHA config before the app mounts.
// This prevents the "Enterprise → v2" fallback race condition.
authService.initRecaptchaConfig();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // NOTE: StrictMode is removed for now because it intentionally double-invokes
  // components in development, which breaks the single-use reCAPTCHA widget.
  // Re-enable once phone auth is stable.
  <App />
);

reportWebVitals();